import styled from '@emotion/styled'

export const StyledAssetTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  td,
  th {
    padding: 8px;
  }

  th {
    background-color: var(--Transparent);
    font-weight: normal;
    text-align: left;
  }

  tbody {
    background-color: var(--White96);
  }

  td {
    border: 2px solid var(--White);
    vertical-align: middle;
  }

  tr:first-of-type td {
    border-top: 0;
  }

  .asset {
    border-left: 0;
    border-right: 0;
    text-align: left;
  }

  .price {
    border-left: 0;
    border-right: 0;
    text-align: right;
  }

  .total {
    border-left: 0;
    text-align: right;
  }

  .weight {
    border-left: 0;
    text-align: right;
  }

  .units {
    border-right: 0;
    text-align: right;
  }

  td.asset {
    border-left: 0;
    border-right: 0;
    button {
      text-align: left;
    }
  }

  td.price {
    border-right: 0;
    width: 150px;
    justify-content: space-between;
    align-items: center;
    input {
      width: calc(100% - 32px);
      padding: 8px 6px;
      margin-right: 6px;
      text-align: center;
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
    input[type='number'] {
      -moz-appearance: textfield;
    }
    button {
      border-radius: 50%;
      width: 26px;
      height: 26px;
      font-weight: 600;
    }
  }

  td.total {
    border-left: 0;
    min-width: 90px;
  }

  td.weight {
    border-left: 0;
    min-width: 90px;
  }

  td.units {
    border-right: 0;
    width: 150px;
    justify-content: space-between;
    align-items: center;
    input {
      width: calc(100% - 32px);
      padding: 8px 6px;
      margin-right: 6px;
      text-align: center;
      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
    input[type='number'] {
      -moz-appearance: textfield;
    }
    button {
      border-radius: 50%;
      width: 26px;
      height: 26px;
      font-weight: 600;
    }
  }

  tr:last-child td {
    border-bottom: 0;
  }
`
